import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import { action, observable } from 'mobx';

export class PayStore {
    rootStore: CXRootStore;

    @observable tipFieldValue: number;

    constructor(rootStore: CXRootStore) {
        this.rootStore = rootStore;
    }

    @action.bound
    setTipFieldValue(value: number) {
        this.tipFieldValue = value;
    }
}
